import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "./Icon";
import analyticsService from "../../services/analyticsService";
import { SUPPORT_PHONE_URL } from "../../constants/support";

// « Ou appeler le service client », proposé sous WhatsApp aux clients qui ne
// l'utilisent pas.
export default function SupportCallLink({ analyticsParams, className = "" }) {
  const { t } = useTranslation();

  return (
    <a
      href={SUPPORT_PHONE_URL}
      onClick={() => analyticsService.pushEvent("support_call_clicked", analyticsParams)}
      className={`self-center flex items-center justify-center gap-1.5 pt-1.5 text-sm font-semibold text-qv-brand underline md:no-underline md:hover:underline ${className}`}
    >
      <Icon name="phone-calling-linear" size={18} />
      {t("support.orCall")}
    </a>
  );
}
